module.exports = __webpack_public_path__ + "img/ywcbig.6316123e.png";